<!-- Load more messages button - OUTSIDE nb-chat to ensure it renders -->
<div class="load-more-wrapper" *ngIf="showLoadMoreButton">
    <button class="load-more-button" (click)="loadMoreMessages()" [disabled]="loadingMore">
        <i class="fa fa-arrow-up" aria-hidden="true" *ngIf="!loadingMore"></i>
        <i class="fa fa-spinner fa-spin" aria-hidden="true" *ngIf="loadingMore"></i>
        <span>{{ "CHAT.LOAD_MORE_MESSAGES" | translate }}</span>
    </button>
</div>

<nb-chat>
    <nb-chat-message *ngFor="let msg of messages" [type]="msg.type" [message]="msg.content" [reply]="msg.reply"
        [sender]="msg.owner.firstName + ' ' + msg.owner.lastName" [date]="msg.createdAt" [dateFormat]="timeFormat"
        [files]="msg.files" [quote]="msg.quote" [latitude]="msg.latitude" [longitude]="msg.longitude"
        [ngClass]="{'message-sent': msg.reply, 'message-received': !msg.reply}">
    </nb-chat-message>

    <nb-chat-form (send)="sendMessage($event)" [showButton]="true" [dropFiles]="true" *ngIf="enableReply">
    </nb-chat-form>
</nb-chat>